import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';

interface DiscardedFieldTooltipSignature {
  Element: HTMLSpanElement;
}

export default class DiscardedFieldTooltip extends Component<DiscardedFieldTooltipSignature> {
  message = "This field was discarded according to your location's data retention policy";

  <template>
    <span
      class="relative inline-flex items-center align-middle ml-1"
      tabindex="0"
      role="img"
      aria-label={{this.message}}
      data-test-discarded-field-tooltip
      ...attributes
    >
      {{svgJar "tooltip-info" class="w-[14px] h-[14px]" aria-hidden="true"}}
      <EmberTooltip @side="top" @delay={{200}} @popperContainer="body" @tooltipClass="!max-w-96">
        {{this.message}}
      </EmberTooltip>
    </span>
  </template>
}
